import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { PageHeader } from './_shared';

const TIPS = [
    {
        title: 'Instagram Business 계정만 가능',
        desc: '개인 계정은 Meta API 권한이 부여되지 않아 자동화가 동작하지 않습니다.',
    },
    {
        title: '24시간 메시지 윈도우',
        desc: '사용자가 마지막 상호작용 후 24시간 이내에만 DM을 자동 발송할 수 있습니다 (Meta 정책).',
    },
    {
        title: '시간당 200건 한도',
        desc: '시간당 최대 200건까지 발송 가능합니다. 초과 시 한도가 풀린 뒤 자동으로 재시도됩니다.',
    },
    {
        title: '자동화 한도 20개',
        desc: '계정당 최대 20개의 자동화를 등록할 수 있습니다.',
    },
];

const HelpPage = () => {
    return (
        <Box>
            <PageHeader title="도움말" desc="자동DM을 시작하기 전에 꼭 알아두면 좋은 내용" />
            <Stack spacing={1.5}>
                {TIPS.map((tip) => (
                    <Card key={tip.title} variant="outlined" sx={{ borderRadius: 3 }}>
                        <CardContent>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
                                {tip.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {tip.desc}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Stack>
        </Box>
    );
};

export default HelpPage;
